import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SetSearchFiltersAction, withFilterState } from "../utils/withFilterState";
import { MaterialInfoFilterState, MaterialInfoSelection } from "./materialInfoTypes";

export const samMaterialInfoSliceName = "samMaterialInfo";

export interface SamMaterialInfoState {
  filters: MaterialInfoFilterState;
  selection: MaterialInfoSelection;
}

const initialState: SamMaterialInfoState = {
  filters: {},
  selection: {
    materialInfoEntries: [],
  },
};

const samSlice = createSlice({
  name: samMaterialInfoSliceName,
  initialState,
  reducers: {
    setMaterialInfoSearchFilters(state: SamMaterialInfoState, action: PayloadAction<SetSearchFiltersAction>) {
      withFilterState(state.filters).setSearchFilters(action.payload);
    },
    setMaterialInfoSelection(state: SamMaterialInfoState, action: PayloadAction<MaterialInfoSelection>) {
      state.selection = action.payload;
    },
  },
});

export interface SamMaterialInfoRootState {
  [samMaterialInfoSliceName]: SamMaterialInfoState;
}

export const selectSamMaterialInfo = (state: SamMaterialInfoRootState) => state[samMaterialInfoSliceName];
export const selectSamMaterialInfoFilters = (state: SamMaterialInfoRootState) => {
  return selectSamMaterialInfo(state).filters;
};
export const selectSamMaterialInfoSelection = (state: SamMaterialInfoRootState) => {
  return selectSamMaterialInfo(state).selection;
};

export const {
  setMaterialInfoSearchFilters,
  setMaterialInfoSelection,
} = samSlice.actions;
export const samMaterialInfoReducer = samSlice.reducer;
